import type { RouteRecordRaw } from 'vue-router';

export const BOM_ROUTER: RouteRecordRaw[] = [
  {
    path: '/bom',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/bom/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/master/bom/views/List.vue'),
        name: 'BOM List',
        meta: {
          title: 'BOM 마스터',
        },
      },
      {
        path: 'create',
        component: () => import('@/modules/master/bom/views/Detail.vue'),
        name: 'BOM Create',
        meta: {
          title: 'BOM 등록',
        },
      },
    ],
  },
  {
    path: '/bom/detail/:no',
    component: () => import('@/modules/master/bom/views/Detail.vue'),
    name: 'BOM Detail',
    meta: {
      title: 'BOM 상세',
      requiresAuth: true,
    },
  },
];
